import { render } from "./sv-custom-table-header.vue?vue&type=template&id=73bf2814&scoped=true&ts=true"
import script from "./sv-custom-table-header.tsx?vue&type=script&lang=tsx&external"
export * from "./sv-custom-table-header.tsx?vue&type=script&lang=tsx&external"

import "./sv-custom-table-header.scss?vue&type=style&index=0&id=73bf2814&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73bf2814"]])

export default __exports__